import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import Context from '../App/MainProvider/context';
import NotificationContext from './NotificationContext';
import { TopBarNotificationAction } from '../Layout/topbar/topBarNotificationReducer';
import notificationService from '../../services/notificationService';
import { MarkNotificationAsRead, NotificationItem } from '../../services/types/Notification';
import { LinkButton } from '../../shared/components';
import NotificationRow from './PopoverNotification';

interface Props {
  dispatch?: React.Dispatch<TopBarNotificationAction>;
}

const LastNotifications: React.FC<Props> = ({ dispatch }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { service } = useContext(Context);
  const { data, reload: reloadNotiications } = useContext(NotificationContext);
  const { unreadItems: unReadNotifications, list: lastNotifications } = data;

  const close = () => dispatch && dispatch({ type: 'SHOW', value: false });

  const handleMarkAllAsRead = () => {
    const callback = () => {
      close();
      reloadNotiications();
    };

    service(() => notificationService.markAllAsRead(), { callback });
  };

  const handleMarkAsRead = (id: number, goTo?: string) => {
    if (!id) {
      return;
    }

    const payload: MarkNotificationAsRead = { id };

    const callback = async (res: NotificationItem | null) => {
      if (res) {
        const unreadNotificationsTotal = unReadNotifications - 1 > 0 ? unReadNotifications - 1 : 0;

        reloadNotiications();
        if (goTo) {
          navigate(goTo, { replace: true });
          navigate(0);
        }

        if (!dispatch) {
          return;
        }

        if (!unreadNotificationsTotal) {
          dispatch({
            type: 'SHOW_POPOVER_AND_SET_DATA',
            showNotificationPopover: false,
            popoverNotifications: lastNotifications,
          });
        } else {
          dispatch({ type: 'SET_DATA', value: lastNotifications });
        }
      }
    };

    service(() => notificationService.markAsRead(payload), { callback });
  };

  const handleResultNavegation = (
    notificationId: number,
    navigationLink: string,
    wasRead: boolean
  ) => {
    const callback = () => {
      reloadNotiications();
      close();
      navigate(navigationLink);
    };

    if (!wasRead) {
      service(() => notificationService.markAsRead({ id: notificationId }), { callback });
    } else {
      callback();
    }
  };

  const navigateToNotifications = () => {
    close();
    if (!(location.pathname.indexOf('/notifications') > -1)) {
      navigate(`/notifications`);
    }
  };

  return (
    <div className="popover__notifications">
      <div className="popover__notifications__header">
        <span>{t('notifications')}</span>
        <LinkButton text={t('markAllAsRead')} className="visited" onClick={handleMarkAllAsRead} />
      </div>
      <div className="popover__notifications__body">
        {lastNotifications &&
          lastNotifications.length > 0 &&
          lastNotifications.map((notification) => (
            <NotificationRow
              key={notification.id}
              notification={notification}
              markAsRead={handleMarkAsRead}
              handleResultNavegation={handleResultNavegation}
            />
          ))}
      </div>
      <div className="popover__notifications__footer">
        <LinkButton text={t('seeAllNotifications')} onClick={navigateToNotifications} />
      </div>
    </div>
  );
};

export default LastNotifications;
